import * as React from "react";
import styled from "styled-components";
import { select } from "@hubper/theme";
import Tile from "./elements/Tile";
import Top from "./elements/Top";
import Bottom from "./elements/Bottom";
import { Title } from "./elements/Typo";
import Icon, { IconName } from "../../elements/Icon";
import Tag from "../../components/Tag";
import WithTooltip from "../../components/WithTooltip";

const LightenColor = (color: string, percent: number): string => {
  const num = parseInt(color.replace("#", ""), 16);
  const amt = Math.round(2.55 * percent);

  /* tslint:disable:no-bitwise */
  const { r, g, b } = {
    r: (num >> 16) + amt,
    b: ((num >> 8) & 0x00ff) + amt,
    g: (num & 0x0000ff) + amt
  };
  /* tslint:enable:no-bitwise */

  return (
    0x1000000 +
    (r < 255 ? (r < 1 ? 0 : r) : 255) * 0x10000 +
    (b < 255 ? (b < 1 ? 0 : b) : 255) * 0x100 +
    (g < 255 ? (g < 1 ? 0 : g) : 255)
  )
    .toString(16)
    .slice(1);
};

type Texts = {
  activeAppTooltip: string;
};

const DEFAULT_TEXTS: Texts = {
  activeAppTooltip: "Deze learning app is actief"
};

type Props = {
  style?: React.CSSProperties;
  className?: string;
  imageSrc: string;
  title: string;
  active: boolean;
  backgroundColor: string;
  tags: string[];
  texts?: Texts;
  onClick?: () => void;
};

type StatusIconProps = {
  name: IconName;
  tooltipText: Texts["activeAppTooltip"];
};

const FilledIcon = styled(Icon)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  bottom: 2px;
  width: 16px;
  height: 16px;
  margin: 0 0 0 3px;
  padding: 2px;
  border-radius: 50%;
  background-color: ${select.color(["success", 4])};
  box-sizing: border-box;
`;

const StatusIcon = ({ name, tooltipText }: StatusIconProps) => {
  return (
    <WithTooltip content={tooltipText} position="top">
      <FilledIcon name={name} c="#ffffff" />
    </WithTooltip>
  );
};

type BackgroundGradientProps = {
  backgroundColor: string;
};

const TopGradient = styled(Top)<BackgroundGradientProps>`
  overflow: hidden;
  &:after {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    content: "";
    opacity: 0.9;
    background: ${p =>
      "linear-gradient(20deg," +
      p.backgroundColor +
      ", #" +
      LightenColor(p.backgroundColor, 40) +
      ")"};
  }
`;

function LearningAppTile(
  // @ts-ignore
  {
    style,
    className,
    imageSrc,
    title,
    onClick,
    active,
    texts = DEFAULT_TEXTS,
    backgroundColor,
    tags = []
  }: Props,
  ref: any
) {
  return (
    <Tile
      disabled
      ref={ref}
      style={style}
      className={className}
      onClick={onClick}
    >
      <TopGradient
        backgroundColor={backgroundColor}
        imageSrc={imageSrc}
      ></TopGradient>
      <Bottom
        topLeft={
          <>
            <Title style={{ marginBottom: 5 }}>
              {title}
              {active && (
                <StatusIcon name="done" tooltipText={texts.activeAppTooltip} />
              )}
            </Title>
            {tags.map(tag => (
              <Tag key={tag} text={tag} />
            ))}
          </>
        }
      />
    </Tile>
  );
}

export default React.forwardRef(LearningAppTile);
